import { FC, ReactNode } from "react";
import classNames from "classnames";
import useEmblaCarousel from "embla-carousel-react";
import { useDirection } from "src/i18n/direction";

export type ScrollableMenuItem = { value: string | number; label: ReactNode };

interface ScrollableMenuProps {
  items: ScrollableMenuItem[];
  selectedItem: string | number;
  onSelect?: (item: ScrollableMenuItem) => void;
  classNames?: { root?: string; item?: string; active?: string };
}

const ScrollableMenu: FC<ScrollableMenuProps> = ({ items, selectedItem, onSelect, classNames: menuClassNames }) => {
  const direction = useDirection();
  const [emblaRef] = useEmblaCarousel({ loop: false, axis: "x", align: "start", dragThreshold: 6, direction, dragFree: true });

  return (
    <div ref={emblaRef} className={classNames("w-full overflow-hidden", menuClassNames?.root)}>
      <div className="flex">
        {items.map((item) => {
          const isActive = item.value === selectedItem;
          return (
            <button
              key={item.value}
              type="button"
              onClick={() => onSelect?.(item)}
              className={classNames(
                "flex shrink-0 cursor-pointer items-center gap-2 whitespace-nowrap p-3 text-sm font-medium transition-colors",
                menuClassNames?.item,
                isActive ? classNames("text-font-active border-current border-b-3", menuClassNames?.active) : "text-font-default hover:text-font-active border-transparent",
              )}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ScrollableMenu;
